import React, { useEffect, useState } from "react";
import {
  Modal,
  Button as Btn,
  Form,
  Input,
  Card,
  message,
  notification,
} from "antd";
import colors from "../../../../share/constants/constants";
import Close from "./../../../../assets/icons/close.svg";
import Button from "../../../../components/common/button";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "../../../../components/common/dropdown";
import { updateParentChildSubCategory } from "../../../../api/service";

const SubCategoryChildModal = ({
  onCancel,
  onOk,
  data,
  text,
  title,
  visible,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [serviceCategory, setServiceCategory] = useState("");
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  const {
    isLoading: loading,
    res: subCategories,
    error,
  } = useSelector((state) => state?.subCategory);

  useEffect(() => {
    const filtered = subCategories?.filter(
      (fd) =>
        !fd?.parent &&
        fd?.serviceCategoryId === data?.serviceCategoryId &&
        fd?._id !== data?._id
    );
    setFilteredSubCategories(filtered);
  }, [subCategories, data]);

  const onFinish = async () => {
    try {
      let payload = {
        parent: serviceCategory,
      };
      const subServiceRes = await updateParentChildSubCategory(
        data?._id,
        payload
      );
      if (subServiceRes) {
        onCancel();
        notification.success({
          title: "Success",
          description: "Updated successfully!",
        });
      }
    } catch (error) {
      notification.error({
        title: "Error",
        description: "Error while modifying the record",
      });
    }
  };

  return (
    <div>
      <Modal
        open={visible}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h3 className="flex-1">Assign Subcategory as Child</h3>
            <img
              src={Close}
              alt="Cross Icon"
              className="w-3.2 hover:cursor-pointer"
              onClick={onCancel}
            />
          </div>
          <p>
            Select the parent subcategory under which this subcategory should be
            nested in the customer app.
          </p>
          <h4>
            {data?.name} ({data?.title})
          </h4>

          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="fex flex-col justify-center">
              <Form.Item
                name="serviceCategoryId"
                label="Choose a Sub Category"
                className="w-full mt-3"
                rules={[{ required: true, message: "field is required" }]}
              >
                <Dropdown
                  className={"h-5 !rounded-lg"}
                  placeholder="Choose a Sub Category"
                  defaultValue={null}
                  loadMoreData={(e) => {}}
                  data={filteredSubCategories}
                  onChange={(e) => {
                    setServiceCategory(e);
                  }}
                />
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                title={data?._id ? `Update` : "Save"}
                color={colors.primaryPurple}
                className="flex items-center w-full"
                htmlType="submit"
                onOk={onCancel}
                // disabled={!form.isFieldsTouched(['name', 'cost'])}
                loading={false}
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default SubCategoryChildModal;
